export function resolvePosition(position, imgLeft, imgTop, imgWidth, imgHeight) {
  const thirdW = imgWidth / 3;
  switch (position) {
    case 'top-left':
      return { left: imgLeft, top: imgTop + 28, width: thirdW };
    case 'top-center':
      return { left: imgLeft + thirdW, top: imgTop + 28, width: thirdW };
    case 'top-right':
      return { left: imgLeft + thirdW * 2, top: imgTop + 28, width: thirdW };
    case 'bottom-title':
      return { left: imgLeft, top: imgTop + imgHeight * 0.70 - 25, width: imgWidth };
    case 'bottom-subtitle':
      return { left: imgLeft, top: imgTop + imgHeight * 0.82, width: imgWidth };
    case 'bottom-cinemas':
      return { left: imgLeft, top: imgTop + imgHeight * 0.89, width: imgWidth };
    case 'bottom-directed':
      return { left: imgLeft, top: imgTop + imgHeight * 0.94, width: imgWidth };
    default:
      return { left: imgLeft, top: imgTop, width: imgWidth };
  }
}
